const getStringNotes = (value: unknown): string[] => {
  if (!Array.isArray(value)) {
    return [];
  }

  return value.filter(
    (note): note is string =>
      typeof note === "string" && note.trim().length > 0,
  );
};

export const getGuestProfileNotes = (preferences: unknown): string[] => {
  if (!preferences) {
    return [];
  }

  if (typeof preferences === "string") {
    try {
      return getGuestProfileNotes(JSON.parse(preferences) as unknown);
    } catch {
      return [];
    }
  }

  if (typeof preferences !== "object" || Array.isArray(preferences)) {
    return [];
  }

  return getStringNotes((preferences as { notes?: unknown }).notes);
};
